import { render, staticRenderFns } from "./RuleManagerPersonId.vue?vue&type=template&id=776b6cb8&scoped=true&"
import script from "./RuleManagerPersonId.vue?vue&type=script&lang=js&"
export * from "./RuleManagerPersonId.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerPersonId.vue?vue&type=style&index=0&id=776b6cb8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b6cb8",
  null
  
)

export default component.exports